// Structural validation, not proof of SAT registration or ownership.
export function normalizeRfc(value: unknown) { return typeof value === 'string' ? value.trim().toUpperCase() : ''; }
export function rfcError(value: unknown) {
  const rfc = normalizeRfc(value);
  if (['XAXX010101000', 'XEXX010101000'].includes(rfc)) return 'RFC_GENERIC_NOT_ALLOWED';
  if (!/^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{2}[0-9A]$/.test(rfc)) return 'RFC_INVALID';
  const date = rfc.slice(-9, -3), year = 2000 + Number(date.slice(0, 2));
  const month = Number(date.slice(2, 4)), day = Number(date.slice(4, 6));
  const parsed = new Date(Date.UTC(year, month - 1, day));
  if (parsed.getUTCFullYear() !== year || parsed.getUTCMonth() !== month - 1 || parsed.getUTCDate() !== day) return 'RFC_INVALID';
  const alphabet = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ';
  const padded = rfc.length === 12 ? ' ' + rfc : rfc;
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += alphabet.indexOf(padded[i]) * (13 - i);
  const remainder = 11 - sum % 11;
  const expected = remainder === 11 ? '0' : remainder === 10 ? 'A' : String(remainder);
  return padded[12] === expected ? null : 'RFC_INVALID';
}
